import { render } from "./RemoveForm.vue?vue&type=template&id=45eb1e4b&scoped=true"
import script from "./RemoveForm.vue?vue&type=script&lang=js"
export * from "./RemoveForm.vue?vue&type=script&lang=js"

import "./RemoveForm.vue?vue&type=style&index=0&id=45eb1e4b&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45eb1e4b"]])

export default __exports__